var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"contact_page"}},[_c('ContactPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }